import { render, staticRenderFns } from "./GroupViewSidebar.vue?vue&type=template&id=82556092&scoped=true&"
import script from "./GroupViewSidebar.vue?vue&type=script&lang=js&"
export * from "./GroupViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GroupViewSidebar.vue?vue&type=style&index=0&id=82556092&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82556092",
  null
  
)

export default component.exports